var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Card',[_c('Table',{attrs:{"stripe":"","border":"","columns":_vm.columns,"data":_vm.caseList,"loading":_vm.showLoading}}),_vm._v(" "),_c('Page',{attrs:{"class-name":"page","total":_vm.total,"page-size":_vm.pageSize,"show-total":"","ransfer":"transfer"},on:{"on-change":_vm.pageNumChange,"on-page-size-change":_vm.onPageSizeChange}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b7320de","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/iview-loader??ref--1-1!./src/components/base/table/SlideTable.vue
// module id = null
// module chunks = 